"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogProducer = /** @class */ (function () {
    function LogProducer(sendToConsole) {
        this.sendToConsole = sendToConsole;
        if (sendToConsole) {
            LogProducer.printWelcomeMessage(sendToConsole);
        }
    }
    LogProducer.printWelcomeMessage = function (sendToConsole) {
        // eslint-disable-next-line no-console
        console.log("%c\uD83D\uDC4B from Monorail%c\n\n" +
            ("We've noticed that you're" + (sendToConsole ? '' : ' not') + " ") +
            "running in debug mode. " +
            ("As such, we will " + (sendToConsole ? 'produce' : 'not produce') + " ") +
            "Monorail events to the console. " +
            ("\n\nIf you want Monorail events to " + (sendToConsole ? 'stop' : 'start') + " ") +
            ("appearing here, %cset debugMode=" + (!sendToConsole).toString() + "%c, ") +
            "for the Monorail Log Producer in your code.", 'font-size: large;', 'font-size: normal;', 'font-weight: bold;', 'font-weight: normal;');
    };
    LogProducer.prototype.produce = function (monorailEvent) {
        if (this.sendToConsole) {
            // eslint-disable-next-line no-console
            console.log('Monorail event produced', monorailEvent);
        }
        return new Promise(function (resolve) {
            resolve(monorailEvent);
        });
    };
    LogProducer.prototype.produceBatch = function (monorailBatchEvent) {
        if (this.sendToConsole) {
            // eslint-disable-next-line no-console
            console.log('Monorail Batch event produced', monorailBatchEvent);
        }
        return new Promise(function (resolve) {
            resolve(monorailBatchEvent);
        });
    };
    return LogProducer;
}());
exports.LogProducer = LogProducer;
